<div class="ap-margin-bottom-3">
    {{ 'financial-obligations.open-ended-credit.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>
<ap-amount-input
    id="openEndedCreditAmount"
    [helpText]="'financial-obligations.open-ended-credit.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="financial-obligations.open-ended-credit.amount.additional-info.title"
    contentKey="financial-obligations.open-ended-credit.amount.additional-info.content"
    modalUrlKey="financial-obligations.open-ended-credit.amount.additional-info.title"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
